/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your organization's private LLM deployments" |
*
* @param {Private_Models_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_subtitle = /** @type {((inputs?: Private_Models_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie die privaten LLM-Bereitstellungen Ihrer Organisation")
	return /** @type {LocalizedString} */ ("Manage your organization's private LLM deployments")
});